import React from "react";
import { HighlightMatch, LongTextLabel, VerifiedBy } from "@sscs/ui";
import styles from "./identitySummary.module.scss";
const IdentitySummary = ({ identity, productRegex, }) => {
    return (React.createElement("div", { className: styles["identity-summary"] },
        React.createElement(VerifiedBy, { verified: identity.verified }),
        React.createElement("div", { className: styles["name-and-version"] },
            productRegex ? (React.createElement(HighlightMatch, { value: identity.product, regex: productRegex })) : (React.createElement("span", null, identity.product)),
            React.createElement(LongTextLabel, { label: `${identity.version} ${identity.version.toLowerCase() === "generic" ? " Version" : ""}`, className: styles.version }))));
};
export default IdentitySummary;
//# sourceMappingURL=IdentitySummary.js.map